import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { acceptBetaSessionFromOpener } from './app/core/auth-me/beta-session-handoff';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
// Registering Syncfusion license key

// registerLicense('ORg4AjUWIQA/Gnt2XVhhQlJHfVtdX2dWfFN0QHNbdV15flBPcC0sT3RfQFhjSnxWdkZhWXtYdXdcQw==');

registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtccXVVRGBYU0ZxVkJWYEo=');

if (environment.production) {
  enableProdMode();
}

acceptBetaSessionFromOpener()
  .finally(() => {
    platformBrowserDynamic().bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });
